<template>
	<div>
		<el-dialog
			:title="isEdit ? '编辑资产' : '新增资产'"
			:visible.sync="dialogVisible"
			width="40%"
			top="10vh"
			:close-on-click-modal="false"
			:before-close="handleClose"
			custom-class="plan-dialog">
			<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="资产编号" prop="assetNo">
							<el-input v-model="form.assetNo" :disabled="isEdit" size="small" placeholder="请填写资产编号" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="资产名称" prop="assetName">
							<el-input v-model="form.assetName" size="small" :disabled="isEdit" placeholder="请填写资产名称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="资产分类" prop="assetCategory">
							<el-select v-model="form.assetCategory" size="small" placeholder="请选择资产分类">
								<el-option
									v-for="(item, index) in $menu.getList('AssetCategory')"
									:key="index"
									:label="item.name"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="所属项目" prop="communityId">
							<el-select v-model="form.communityId" size="small" disabled placeholder="请选择所属项目">
								<el-option
									v-for="item in CurrentCommunity"
									:key="item.communityId"
									:label="item.name"
									:value="item.communityId" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="位置信息" prop="location">
							<el-input v-model="form.location" size="small" readonly placeholder="请选择位置信息">
								<!-- 右侧操作区域 -->
								<template slot="suffix">
									<span class="map-select-btn" @click="openMap">
										<i class="el-icon-location"></i>
										地图选点
									</span>
								</template>
							</el-input>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="建筑面积(㎡)" prop="buildingArea">
							<el-input v-model="form.buildingArea" size="small" placeholder="请选择位置信息" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="使用面积(㎡)" prop="useArea">
							<el-input v-model="form.useArea" size="small" placeholder="请填写使用面积" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="资产原值(元)" prop="originalValue">
							<el-input v-model="form.originalValue" size="small" placeholder="请填写资产原值" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="土地价值(元)" prop="landValue">
							<el-input v-model="form.landValue" size="small" placeholder="请填写土地价值" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="产权归属" prop="propertyCertificate">
							<el-input v-model="form.propertyCertificate" size="small" placeholder="请填写产权归属" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="资产状态" prop="status">
							<el-select v-model="form.status" size="small" placeholder="请选择资产状态">
								<el-option
									v-for="(item, index) in $menu.getList('AssetStatus')"
									:key="index"
									:label="item.name"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="建档日期" prop="recordDate">
							<el-date-picker
								v-model="form.recordDate"
								type="date"
								value-format="yyyy-MM-dd"
								size="small"
								style="width: 100%"
								placeholder="请选择建档日期" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="规划类型" prop="planningType">
							<el-select v-model="form.planningType" size="small" placeholder="请选择规划类型">
								<el-option
									v-for="item in $menu.getList('PlanningType')"
									:key="item.value"
									:label="item.name"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<el-form-item label="备注" prop="remark">
							<el-input v-model="form.remark" type="textarea" rows="3" size="small" placeholder="请填写备注" />
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<el-form-item label="产权证明" prop="ownershipCertificate">
							<FileUpload :showTip="false" :limit="3" :accept="['jpg', 'png']" v-model="uploadFiles" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item>
							<el-checkbox v-model="form.checked">生成二维码</el-checkbox>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>

			<!-- 按钮 -->
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
		<MapPickerDialog :dialogMapVisible.sync="mapDialogVisible" :address="address" @confirm="handleMapConfirm" />
	</div>
</template>

<script>
	import { getAssetSave, getAssetUpdate } from '@/api/asset/assetLedgerApi.js';
	import { getCurrentCommunity, getCommunityId } from '@/utils/vc.js';
	export default {
		name: 'AssetLedgerDialog',
		props: {
			dialogVisible: Boolean,
			isEdit: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				mapDialogVisible: false,
				uploadFiles: [],
				form: {
					assetNo: '',
					assetName: '',
					assetCategory: '',
					communityId: getCommunityId(),
					location: '',
					lat: '',
					lng: '',
					buildingArea: '',
					useArea: '',
					originalValue: '',
					landValue: '',
					propertyCertificate: '',
					status: '',
					recordDate: '',
					planningType: '',
					remark: '',
					ownershipCertificate: '',
				},
				address: {
					location: '',
					lat: '',
					lng: '',
				},
				rules: {
					assetNo: [{ required: true, message: '请输入资产编号', trigger: 'blur' }],
					assetName: [{ required: true, message: '请输入资产名称', trigger: 'blur' }],
					assetCategory: [{ required: true, message: '请输入资产分类', trigger: 'blur' }],
					communityId: [{ required: true, message: '请输入所属项目', trigger: 'blur' }],
					location: [{ required: true, message: '请选择位置信息', trigger: 'change' }],
					buildingArea: [
						{ required: true, message: '请输入建筑面积', trigger: 'blur' },
						{
							pattern: /^\d+(\.\d+)?$/,
							message: '请输入正确的数字',
							trigger: 'blur',
						},
					],
					originalValue: [
						{ required: true, message: '请输入资产原值', trigger: 'blur' },
						{
							pattern: /^\d+(\.\d+)?$/,
							message: '请输入正确的数字',
							trigger: 'blur',
						},
					],
					ownership: [{ required: true, message: '请输入产权归属', trigger: 'blur' }],
					status: [{ required: true, message: '请选择资产状态', trigger: 'change' }],
					recordDate: [{ required: true, message: '请选择建档日期', trigger: 'change' }],
				},
				CurrentCommunity: [getCurrentCommunity()],
			};
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						if (this.isEdit) {
							Object.assign(this.form, this.data);
							this.address = {
								location: this.data.location,
								lat: Number(this.data.lat),
								lng: Number(this.data.lng),
							};
						} else {
							this.$refs.form && this.$refs.form.resetFields();
							this.uploadFiles = [];
						}
					});
				}
			},
		},
		methods: {
			handleMapConfirm(val) {
				this.address = val;
				this.form.location = val.location;
				this.form.lat = val.lat;
				this.form.lng = val.lng;
				this.mapDialogVisible = false;
			},
			handleClose() {
				this.uploadFiles = [];
				this.$emit('update:dialogVisible', false);
			},
			resetForm() {
				this.form = {
					assetNo: '',
					assetName: '',
					assetCategory: '',
					projectId: getCommunityId(),
					location: '',
					address: '',
					buildingArea: '',
					usableArea: '',
					originalValue: '',
					landValue: '',
					ownership: '',
					assetStatus: '',
					recordDate: '',
					planningType: '',
					remark: '',
					propertyCertificate: '',
					ownershipCertificate: '',
				};
			},
			openMap() {
				this.mapDialogVisible = true;
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;

					if (this.isEdit) {
						console.log('编辑数据', this.form);
						getAssetUpdate(this.form)
							.then(res => {
								console.log(res, 'getAssetUpdate');
								this.$message.success('编辑成功');
								this.$emit('updateSuccess');
							})
							.catch(err => {
								console.log(err);
								this.$message.error('编辑失败');
							});
					} else {
						console.log('新增数据', this.form);
						getAssetSave(this.form)
							.then(res => {
								console.log(res, 'getAssetSave');
								this.$message.success('新增成功');
								this.$emit('updateSuccess');
							})
							.catch(err => {
								console.log(err);
								this.$message.error('新增失败');
							});
					}
					this.handleClose();
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	.map-select-btn {
		color: #4080ff;
		cursor: pointer;
	}
	:deep(.plan-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}
</style>
